export class TranslationRequest {
    key: string;
    language: string;
    contNum: number;
    tableName: string;
    primaryKey: string;
    primaryValue: string;
    lob: string;
    group: string;
    subGroup: string;    
    multipleKeyAllowed?: string | null;
    saveToCache?: boolean = true;

    constructor(values: TranslationRequest) {
        Object.assign(this, values);
    }
}
